exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".jumbotron .jumbotron_body{padding:40px 0}.jumbotron .jumbotron_body h2{word-break:break-word}@media (max-width:768px){.jumbotron .jumbotron_body h2{font-size:30px}}.jumbotron .jumbotron_bar{padding:10px 0 5px 0}", "", {"version":3,"sources":["/opt/snt/front-end-turnos/src/app/turnos/shared/jumbotron/jumbotron.component.scss"],"names":[],"mappings":"AAGA,2BACI,cAAe,CADnB,8BAGK,qBAAsB,CACtB,yBAJL,8BAOM,cAAe,CACf,CAAA,0BAKF,oBAAqB,CACxB","file":"jumbotron.component.scss","sourcesContent":["\n\n\n.jumbotron .jumbotron_body {\n    padding: 40px 0;\n    h2 {\n    \tword-break: break-word;\n    }\n    @media (max-width: 768px) {\n        h2 {\n    \t\tfont-size: 30px;\n    \t}\n    }\n}\n\n.jumbotron .jumbotron_bar {\n    padding: 10px 0 5px 0;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/snt/front-end-turnos/src/app/turnos/shared/jumbotron/jumbotron.component.scss
// module id = Q8VS
// module chunks = 2